import React from "react";
import { Dropdown, Menu, Button } from "antd";
import { ButtonType } from "antd/lib/button";

export interface TGridAction {
  type: ButtonType;
  label: string;
  visibleActionProp?: string;
  onClick: (record: any) => (e: any) => void;
  enable?: (record: any) => boolean;
  loading?: (record: any) => boolean;
}
export interface Props {
  actions: TGridAction[];
  record: any;
}

export interface State {}
export default class GridActionsDropdown extends React.Component<Props, State> {
  isDropdownButtonDisabled() {
    const { record, actions } = this.props;
    const enabledActions = actions.filter(
      (action: TGridAction) =>
        (action.enable && action.enable(record)) || !action.enable
    );
    return enabledActions.length === 0;
  }
  render() {
    const { actions, record } = this.props;
    if (!actions.find((item) => item.type === "primary")) {
      actions[0].type = "primary";
    }
    const primaryAction = actions.find((item) => item.type === "primary");

    return (
      <React.Fragment>
        {actions.length > 1 ? (
          <Dropdown.Button
            disabled={this.isDropdownButtonDisabled()}
            type="primary"
            onClick={(primaryAction as any).onClick(record)}
            overlay={
              <Menu>
                {actions
                  .filter((item) => (item as any).type !== "primary")
                  .map((action, index) => {
                    return (
                      <Menu.Item
                        disabled={
                          (action as any).enable
                            ? !(action as any).enable(record)
                            : false
                        }
                        style={
                          (action as any).type === "danger"
                            ? { color: "red" }
                            : {}
                        }
                        key={`action-${index.toString()}`}
                        onClick={(action as any).onClick(record)}
                      >
                        {(action as any).label}
                      </Menu.Item>
                    );
                  })}
              </Menu>
            }
          >
            {(primaryAction as any).label}
          </Dropdown.Button>
        ) : (
          <Button
            type={(actions[0] as any).type}
            disabled={
              (actions[0] as any).enable
                ? !(actions[0] as any).enable(record)
                : false
            }
            key={`action-1`}
            onClick={(actions[0] as any).onClick(record)}
            style={{
              display:
                (actions[0] as any).visibleActionProp &&
                !record[(actions[0] as any).visibleActionProp]
                  ? "none"
                  : undefined
            }}
            loading={
              (actions[0] as any).loading
                ? (actions[0] as any).loading(record)
                : false
            }
          >
            {(actions[0] as any).label}
          </Button>
        )}
      </React.Fragment>
    );
  }
}
